<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 0, 18, 0]">
        <v-tooltip />
        <v-smooth-area position="x*y" />
      </v-chart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
const mockData = []
const beginDay = new Date().getTime()

for (let i = 0; i < 10; i++) {
  mockData.push({
    x: moment(new Date(beginDay + 1000 * 60 * 60 * 24 * i)).format('YYYY-MM-DD'),
    y: Math.round(Math.random() * 10)
  })
}

const tooltip = [
  'x*y',
  (x, y) => ({
    name: x,
    value: y
  })
]
const scale = [{
  dataKey: 'x',
  min: 2,
  alias: '月份'
}, {
  dataKey: 'y',
  min: 1,
  max: 22,
  alias: '金额'
}]

export default {
  name: 'MiniArea',
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      data: mockData,
      tooltip,
      scale,
      height: 100
    }
  },
  created () {
    // console.log(this.chartData)
    // const data = []
    // this.chartData.forEach(obj => {
    //   data.push({
    //     x: obj.date,
    //     y: obj.value
    //   })
    // })
    // console.log(data)
    // this.data = data.length ? data : mockData
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>
